import { Swiper } from 'swiper';
import { A11y, Navigation, Thumbs } from 'swiper/modules';

const sliders = document.querySelectorAll(
	'.block-hero-product-images .swiper:first-child'
);

const handleKeyDown = (primarySlider, thumbnailSlider, e) => {
	if (e.key !== 'Enter' && e.key !== ' ') {
		return;
	}

	const thumbnailIndex = Array.from(
		e.currentTarget.parentElement.children
	).indexOf(e.currentTarget);

	primarySlider.slideTo(thumbnailIndex);
	thumbnailSlider.slideTo(thumbnailIndex);
};

if (sliders.length > 0) {
	sliders.forEach((slider) => {
		const settings = {
			loop: true,
			grabCursor: true,
			spaceBetween: 16,
			slidesPerView: 1,
			modules: [A11y, Navigation],
			a11y: {
				itemRoleDescriptionMessage: 'slide',
			},
			navigation: {
				prevEl: slider.parentElement.querySelector(
					'.swiper-button-prev'
				),
				nextEl: slider.parentElement.querySelector(
					'.swiper-button-next'
				),
			},
		};

		let thumbnailSlider;

		if (
			slider.nextElementSibling &&
			slider.nextElementSibling.classList.contains('swiper')
		) {
			const thumbnailSliderSettings = {
				grabCursor: true,
				spaceBetween: 16,
				slidesPerView: 'auto',
				watchSlidesProgress: true,
				slideToClickedSlide: true,
				modules: [A11y],
				a11y: {
					itemRoleDescriptionMessage: 'slide',
					slideLabelMessage:
						'View product image {{index}} / {{slidesLength}}',
				},
				breakpoints: {
					992: {
						slidesPerView: 'auto',
						direction: 'vertical',
					},
				},
			};

			thumbnailSlider = new Swiper(
				slider.nextElementSibling,
				thumbnailSliderSettings
			);

			settings.modules = [A11y, Thumbs, Navigation];
			settings.thumbs = {
				swiper: thumbnailSlider,
				autoScrollOffset: 1,
			};
		}

		const primarySlider = new Swiper(slider, settings);

		if (
			slider.nextElementSibling &&
			slider.nextElementSibling.classList.contains('swiper')
		) {
			const thumbnailButtons =
				slider.nextElementSibling.querySelectorAll('button');

			if (thumbnailButtons.length > 0) {
				thumbnailButtons.forEach((thumbnailButton) => {
					thumbnailButton.addEventListener(
						'keydown',
						handleKeyDown.bind(null, primarySlider, thumbnailSlider)
					);
				});
			}
		}
	});
}
